<template>
  <div class="news-item-list">
    <div v-for="(itemNsL,index) in newsList" :key="index">
      <div class="list-item">
        <div class="news-item-img" @click="readNews(itemNsL.newsId)">
          <img :src="itemNsL.newsMainImg" width="156" height="101" alt="">
        </div>
        <div class="news-item-text">
          <div class="text-title" @click="readNews(itemNsL.newsId)">{{itemNsL.newsTitle}}</div>
          <div class="text-time">{{itemNsL.newsDate}}</div>
          <div class="text-content">{{itemNsL.newsSummary}}</div>
        </div>
      </div>
      <div class="hr-type">
        <hr class="hr-style" />
      </div>
    </div>
    <div class="news_page">
      <el-pagination :page-size="pageSize" layout="prev, pager, next" :total="totalPage" @current-change="turnPage" background class="pager_style">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getNewsListByPageNoSize } from '@/api/frontApi/frontNews';
export default {
  data() {
    return {
      newsObj: [],
      newsList: [],
      newsListNo: 500, // 新闻列表展示条数
      newsType: 2, // 2行业动态，3企业要闻
      pageSize: 6,
      pageNo: 1,
      totalPage: 1
    };
  },
  created() {
    this.getListInfo();
  },
  computed: {
    defaultImg() {
      return this.$store.state.defaultImg;
    }
  },
  methods: {
    getListInfo() {
      getNewsListByPageNoSize({
        newsType: this.newsType,
        pageSize: this.pageSize,
        pageNo: this.pageNo
      }).then(res => {
        res.data.list.forEach(item => {
          if (!item.newsMainImg) {
            item.newsMainImg = this.defaultImg;
          }
        });
        this.newsList = res.data.list;
        this.totalPage = res.data.totalCount;
      });
    },
    turnPage(val) {
      this.pageNo = val;
      this.getListInfo();
    },
    readNews(newsId) {
      this.$router.push({
        name: 'newsInfo',
        params: {
          newsId: newsId
        }
      });
      // this.$emit('whichNewsToShow', newsObject);
    }
  }
};
</script>
<style scoped>
.news-item-list {
  width: 100%;
  min-height: 600px;
  min-width: 696px;
}
.list-item {
  width: 100%;
  overflow: hidden;
  margin-bottom: 10px;
  cursor: pointer;
  min-width: 690px;
}

.news-item-img {
  float: left;
  width: 22%;
  min-width: 156px;
}
.news-item-text {
  float: left;
  margin-left: 1%;
  width: 74%;
  min-width: 340px;
}
.text-title {
  font-size: 16px;
}
.text-title:hover {
  color: #55afdf;
}
.text-time {
  margin-top: 5px;
}
.text-content {
  margin-top: 5px;
  height: 57px;
  text-overflow: ellipsis; /* 超出部分显示省略号 */
}
img {
  vertical-align: middle;
}
.hr-type {
  width: 100%;
  margin-bottom: 12px;
}
.hr-style {
  background-color: #dcdcdc;
  height: 1px;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/news/newsList.vue